import * as React from 'react';
import ReactDOM from 'react-dom';

import Keyboard from 'app/Keyboard';
import BaseItemView from 'app/src/views/base/BaseItemView';

import { GiftCardScan } from './GiftCardScan';

const _Events = {
  CANCEL_BUTTON_CLICKED: 'cancel:button:clicked',
  SUBMIT_GIFT_CARD_REQUESTED: 'submit:gift:card:requested',
};

// configure
let View = BaseItemView.extend({
  template: false,
  onRender() {
    ReactDOM.render(<GiftCardScan viewData={this.viewData} />, this.el);
  },
  onDestroy() {
    ReactDOM.unmountComponentAtNode(this.el);
  },
  ui: {
    giftCardInput: '#gift_card_input',
    goButton: '#scanGiftCardGoButton',
    cancelButton: '#scanGiftCardCancelButton',
  },

  events: {
    'keypress @ui.giftCardInput': 'onGiftCardInputKeypress',
    'click @ui.goButton': 'onGoButtonClicked',
  },

  triggers: {
    'click @ui.cancelButton': _Events.CANCEL_BUTTON_CLICKED,
  },
});

// Defined
export default class PaymentScanGiftCardView extends View {
  static get Events() {
    return _Events;
  }

  /**
   * Event handler for when a key is pressed in the gift card input.  When the
   * enter key is pressed an event is triggered.
   *
   * @param event {Event} The triggering DOM event
   */
  onGiftCardInputKeypress(event) {
    if (event.keyCode === Keyboard.KeyCode.ENTER) {
      this.onGoButtonClicked();
    }
  }

  /**
   * Event handler for when the go button is clicked.
   */
  onGoButtonClicked() {
    this.trigger(_Events.SUBMIT_GIFT_CARD_REQUESTED, this.ui.giftCardInput.val());
  }

  /**
   * Sets the focus on the Gift Card Input field
   */
  setFocusOnGiftCardInput() {
    this.ui.giftCardInput.trigger('focus');
  }
}
